var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":_vm.speakerLink}},[_c('div',{staticClass:"mx-auto mt-4"},[_c('img',{staticClass:"inline-block h-24 w-24 rounded-full text-white shadow-solid",attrs:{"src":_vm.speakerImage,"alt":""}}),_c('div',{staticClass:"text-gray-700 font-semibold mt-2 text-xl"},[_c('span',[_vm._v(_vm._s(_vm.speaker.name))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }